module.exports = __webpack_public_path__ + "static/media/ic_file_upload_success.3ce9a968.png";